import React from 'react';
import { formatDisplayDateTime } from 'src/helpers/date.helpers';

interface OverviewAnswerFeedbackProps {
  feedback: string;
  author?: string;
  createdAt?: string;
}

const OverviewAnswerFeedback: React.FC<OverviewAnswerFeedbackProps> = ({ feedback, author, createdAt }) => {
  return (
    <div className="bg-gray-100 rounded-md p-3 mb-2">
      <div className="text-gray-800 text-sm mb-1">
        {feedback}
      </div>
      <div className="text-xs text-gray-500 flex justify-end">
        {author && (
          <span>
            By
            {author}
          </span>
        )}
        {createdAt && (
          <span>
            {formatDisplayDateTime(createdAt)}
          </span>
        )}
      </div>
    </div>
  );
};

export default OverviewAnswerFeedback;
